import { render, staticRenderFns } from "./TruckSupply.vue?vue&type=template&id=ab000e24&"
import script from "./TruckSupply.vue?vue&type=script&lang=js&"
export * from "./TruckSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports